type MaterialGroup = {
  group: string;
  options: Array<Record<string, unknown>>;
};

const getDesignCodeValue = (option: Record<string, unknown>) => {
  const candidates = [option.design_code, option.design_code_name, option.type_name, option.codebook];

  for (const candidate of candidates) {
    if (typeof candidate === "string" && candidate.trim().length > 0) {
      return candidate.trim();
    }
  }

  return null;
};

export const filterMaterialGroupsByDesignCode = <T extends MaterialGroup>(
  groups: T[] | undefined,
  designCode?: string | null
): T[] | undefined => {
  if (!groups || !designCode) {
    return groups;
  }

  const normalizedDesignCode = designCode?.toString()?.trim().toLowerCase();
  const hasDesignCodeData = groups.some((group) => group.options.some((option) => getDesignCodeValue(option)));

  if (!hasDesignCodeData) {
    return groups;
  }

  const filtered = groups
    .map((group) => ({
      ...group,
      options: group.options.filter((option) => {
        const optionCode = getDesignCodeValue(option);
        return optionCode ? optionCode.toLowerCase() === normalizedDesignCode : false;
      }),
    }))
    .filter((group) => group.options.length > 0);

  return filtered as T[];
};
